import React from "react";

const customers = [
  { email: "asdwer@gmail.com", name: "jabir khan", roles: "Registered", company: "", active: true },
  { email: "abc@gmail.com", name: "faris muhammad", roles: "Registered", company: "", active: true },
  { email: "jabir@gmail.com", name: "jabir ep", roles: "Registered", company: "", active: true },
  { email: "steve_gates@routekart.com", name: "Steve Gates", roles: "Registered", company: "", active: true },
  { email: "arthur_holmes@routekart.com", name: "Arthur Holmes", roles: "Registered", company: "", active: true },
  { email: "james_pan@routekart.com", name: "James Pan", roles: "Registered", company: "", active: true },
  { email: "brenda_lindgren@routekart.com", name: "Brenda Lindgren", roles: "Registered", company: "", active: true },
  { email: "victoria_victoria@routekart.com", name: "Victoria Terces", roles: "Registered", company: "", active: true },
  { email: "admin@yourStore.com", name: "John Smith", roles: "Administrators, Forum Moderators, Registered", company: "", active: true },
];

const CustomersTable = () => {
  return (
    <div className="bg-gray-50 min-h-screen p-6 md:p-12 2xl:p-16">
      {/* Learn more link */}
      <div className="bg-white rounded-lg shadow border border-gray-200 p-6 md:p-8">
        <p className="text-gray-600 mb-5 text-base md:text-lg">
          Learn more about{" "}
          <a href="#" className="text-blue-600 hover:underline">
            customers
          </a>
        </p>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm md:text-base text-left">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="px-5 py-4 border-b">
                  <input type="checkbox" className="w-5 h-5" />
                </th>
                <th className="px-5 py-4 font-semibold border-b">Email</th>
                <th className="px-5 py-4 font-semibold border-b">Name</th>
                <th className="px-5 py-4 font-semibold border-b">Customer roles</th>
                <th className="px-5 py-4 font-semibold border-b">Company name</th>
                <th className="px-5 py-4 font-semibold border-b text-center">Active</th>
                <th className="px-5 py-4 font-semibold border-b text-center">Edit</th>
              </tr>
            </thead>

            <tbody>
              {customers.map((customer, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition-all`}
                >
                  <td className="px-5 py-5 border-b">
                    <input type="checkbox" className="w-5 h-5" />
                  </td>
                  <td className="px-5 py-5 border-b text-blue-700 break-words">{customer.email}</td>
                  <td className="px-5 py-5 border-b capitalize">{customer.name}</td>
                  <td className="px-5 py-5 border-b">{customer.roles}</td>
                  <td className="px-5 py-5 border-b">{customer.company}</td>
                  <td className="px-5 py-5 border-b text-center">
                    {customer.active && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600 mx-auto"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293A1 1 0 003.293 10.707l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </td>
                  <td className="px-5 py-5 border-b text-center">
                    <button className="flex items-center bg-gray-100 border border-gray-300 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded mx-auto transition-all">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-1"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5h2M12 5v14m0 0l5-5m-5 5l-5-5"
                        />
                      </svg>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex flex-col sm:flex-row justify-between items-center mt-8 gap-4 text-base">
          <div className="flex items-center space-x-3">
            <button className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-5 py-2 rounded">
              Previous
            </button>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded">
              1
            </button>
            <button className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-5 py-2 rounded">
              Next
            </button>
          </div>

          <div className="flex items-center space-x-3">
            <span className="text-gray-600">Show</span>
            <select className="border border-gray-300 rounded px-3 py-2 text-gray-700">
              <option>5</option>
              <option>10</option>
              <option selected>15</option>
              <option>25</option>
            </select>
            <span className="text-gray-600">items</span>
          </div>

          <div className="text-gray-600 text-sm md:text-base">1-9 of 9 items</div>
        </div>
      </div>
    </div>
  );
};

export default CustomersTable;
